import { render, staticRenderFns } from "./Promotion_new.vue?vue&type=template&id=1e645566&"
import script from "./Promotion_new.vue?vue&type=script&lang=js&"
export * from "./Promotion_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports